(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spt-main-product')) {
    class SptMainProduct extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.current = 0;
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.showMedia(this.current - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.showMedia(this.current + 1));
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.showMedia(Number(thumb.dataset.galleryThumb))));

        const quantity = this.querySelector('[data-quantity-input]');
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
          quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
        });
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
          quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
        });

        this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
        this.querySelectorAll('[data-option-value]').forEach((input) => input.addEventListener('change', () => this.updateVariant()));
        this.openInformation = () => {
          const target = Array.from(this.querySelectorAll('details[id]')).find((item) => '#' + item.id === window.location.hash);
          if (target) {
            target.open = true;
            target.scrollIntoView({ block: 'start' });
          }
        };
        window.addEventListener('hashchange', this.openInformation);
        this.informationClick = (event) => {
          const href = event.target.closest('a')?.getAttribute('href');
          const target = Array.from(this.querySelectorAll('details[id]')).find((item) => '#' + item.id === href);
          if (target) target.open = true;
        };
        document.addEventListener('click', this.informationClick);
        this.openInformation();
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.openInformation);
        document.removeEventListener('click', this.informationClick);
      }

      showMedia(index) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        this.thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === this.current;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        const counter = this.querySelector('[data-gallery-current]');
        if (counter) counter.textContent = String(this.current + 1);
      }

      updateVariant() {
        const selected = Array.from(this.querySelectorAll('[data-option-index]')).map((group) => {
          const checked = group.querySelector('[data-option-value]:checked');
          const output = group.querySelector('[data-selected-option]');
          if (output && checked) output.textContent = checked.value;
          return checked?.value;
        });
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
        const idInput = this.querySelector('[data-variant-id]');
        const button = this.querySelector('[data-add-to-cart]');
        const label = this.querySelector('[data-add-label]');
        const status = this.querySelector('[data-variant-status]');
        if (!variant) {
          button.disabled = true;
          label.textContent = '選択できません';
          return;
        }
        idInput.value = variant.id;
        button.disabled = !variant.available;
        label.textContent = variant.available ? 'カートに追加' : '売り切れ';
        const price = this.querySelector('[data-price-value]');
        if (price) {
          price.textContent = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: this.dataset.currency, maximumFractionDigits: 0 }).format(variant.price / 100);
        }
        if (status) status.textContent = variant.available ? '選択した商品は購入できます。' : '選択した商品は売り切れです。';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    customElements.define('spt-main-product', SptMainProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spt-product-information"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spt-product-information')) {
    class SptProductInformation extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');

        for (const thumb of this.thumbs) thumb.addEventListener('click', () => this.showMedia(Number(thumb.dataset.galleryThumb)));
        for (const input of this.querySelectorAll('[data-option-value]')) input.addEventListener('change', () => this.updateVariant());
        this.querySelector('[data-mobile-buy]')?.addEventListener('click', () => this.querySelector('[data-add-to-cart]')?.click());
      }

      showMedia(index) {
        if (!this.slides.length) return;
        for (const [slideIndex, slide] of this.slides.entries()) {
          const active = slideIndex === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        }
        for (const [thumbIndex, thumb] of this.thumbs.entries()) {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        }
        const counter = this.querySelector('[data-gallery-current]');
        if (counter) counter.textContent = String(index + 1);
      }

      updateVariant() {
        const selectedOptions = [];
        for (const group of this.querySelectorAll('[data-option-index]')) {
          const checked = group.querySelector('[data-option-value]:checked');
          const output = group.querySelector('[data-selected-option]');
          if (output && checked) output.textContent = checked.value;
          selectedOptions.push(checked?.value);
        }
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
        if (!variant) return;

        for (const input of this.querySelectorAll('[data-variant-id]')) input.value = variant.id;
        for (const button of this.querySelectorAll('[data-add-to-cart], [data-mobile-buy]')) button.disabled = !variant.available;
        for (const label of this.querySelectorAll('[data-add-label]')) label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        for (const price of this.querySelectorAll('[data-price-value]')) price.textContent = this.formatMoney(variant.price);
        for (const sku of this.querySelectorAll('[data-sku]')) sku.textContent = variant.sku || '—';

        const featuredMediaId = variant.featured_media?.id;
        if (featuredMediaId) {
          const featuredSlide = this.slides.findIndex((slide) => Number(slide.dataset.galleryMediaId) === Number(featuredMediaId));
          if (featuredSlide >= 0) this.showMedia(featuredSlide);
        }

        const inventory = this.querySelector('[data-inventory-status]');
        if (inventory) {
          inventory.textContent = variant.available ? this.dataset.inStockLabel : this.dataset.outOfStockLabel;
          inventory.classList.toggle('is-unavailable', !variant.available);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        this.announce(`${variant.title} ${this.formatMoney(variant.price)}`);
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: this.dataset.currency, maximumFractionDigits: 0 }).format(cents / 100);
      }

      announce(message) {
        const liveRegion = this.querySelector('[data-live-region]');
        if (!liveRegion) return;
        liveRegion.textContent = '';
        requestAnimationFrame(() => { liveRegion.textContent = message; });
      }
    }
    customElements.define('spt-product-information', SptProductInformation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spt-reference-pdp-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spt-reference-product')) {
    class SptReferenceProduct extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.current = 0;
        for (const thumb of this.thumbs) {
          thumb.addEventListener('click', () => this.showMedia(Number(thumb.dataset.galleryThumb)));
        }

        this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
        for (const input of this.querySelectorAll('[data-option-value]')) {
          input.addEventListener('change', () => this.updateVariant());
        }
      }

      showMedia(index) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        for (const [slideIndex, slide] of this.slides.entries()) {
          const active = slideIndex === this.current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        }
        for (const [thumbIndex, thumb] of this.thumbs.entries()) {
          const active = thumbIndex === this.current;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        }
        const counter = this.querySelector('[data-gallery-current]');
        if (counter) counter.textContent = String(this.current + 1);
      }

      updateVariant() {
        const selected = [];
        for (const group of this.querySelectorAll('[data-option-index]')) {
          const checked = group.querySelector('[data-option-value]:checked');
          const output = group.querySelector('[data-selected-option]');
          if (output && checked) output.textContent = checked.value;
          selected.push(checked?.value);
        }
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
        const idInput = this.querySelector('[data-variant-id]');
        const button = this.querySelector('[data-add-to-cart]');
        const label = this.querySelector('[data-add-label]');
        if (!variant || !idInput || !button || !label) return;
        idInput.value = variant.id;
        button.disabled = !variant.available;
        label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        for (const price of this.querySelectorAll('[data-price-value]')) {
          price.textContent = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: this.dataset.currency, maximumFractionDigits: 0 }).format(variant.price / 100);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    customElements.define('spt-reference-product', SptReferenceProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sptebik-navigation-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spt-site-navigation')) {
    customElements.define('spt-site-navigation', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const menus = this.querySelectorAll('.spt-model-menu');
        for (const menu of menus) {
          menu.addEventListener('toggle', () => {
            if (!menu.open) return;
            for (const other of menus) if (other !== menu) other.open = false;
          }, options);
        }
        for (const desktop of this.querySelectorAll('.spt-v3-header__desktop .spt-model-menu')) {
          desktop.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) {
              clearTimeout(this.closeTimer);
              for (const other of menus) if (other !== desktop) other.open = false;
              desktop.open = true;
            }
          }, options);
          desktop.addEventListener('pointerleave', () => {
            this.closeTimer = setTimeout(() => {
              if (!desktop.contains(document.activeElement)) desktop.open = false;
            }, 180);
          }, options);
        }
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const details = event.target.closest('details[open]');
          if (!details) return;
          details.open = false;
          details.querySelector('summary').focus();
          event.stopPropagation();
        }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            for (const details of this.querySelectorAll('details[open]')) {
              if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
            }
          });
        }, options);
        document.addEventListener('click', (event) => {
          if (this.contains(event.target)) return;
          for (const details of this.querySelectorAll('details[open]')) details.open = false;
        }, options);
      }
      disconnectedCallback() {
        this.events.abort();
        clearTimeout(this.closeTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sptebik-navigation"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sptebik-navigation]').forEach((navigation) => {
    if (navigation.dataset.sptebikReady === 'true') return;
    const toggle = navigation.querySelector('[data-sptebik-menu-toggle]');
    const menu = navigation.querySelector('[data-sptebik-mobile-menu]');
    toggle?.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
    });
    navigation.dataset.sptebikReady = 'true';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sptebik-product-commerce-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spt-pdp-commerce')) {
    customElements.define('spt-pdp-commerce', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
        this.index = 0;
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.thumbs.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.galleryThumb))));
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.quantity(-1));
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.quantity(1));
        this.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', () => this.updateVariant()));
      }
      show(next) {
        if (!this.slides.length) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; slide.classList.toggle('is-active', index === this.index); });
        this.thumbs.forEach((thumb, index) => { thumb.classList.toggle('is-active', index === this.index); thumb.setAttribute('aria-current', index === this.index ? 'true' : 'false'); });
        const current = this.querySelector('[data-gallery-current]');
        if (current) current.textContent = String(this.index + 1);
      }
      quantity(delta) {
        const input = this.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = String(Math.max(1, Number(input.value || 1) + delta));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateVariant() {
        const data = this.querySelector('[data-product-variants]');
        if (!data) return;
        const options = [...this.querySelectorAll('[data-option-position]:checked')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
        const variants = JSON.parse(data.textContent);
        const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
        if (!variant) return;
        this.querySelector('[data-variant-id]').value = variant.id;
        const button = this.querySelector('[data-add-button]');
        const label = this.querySelector('[data-add-label]');
        const purchaseEnabled = !this.querySelector('.spt-pdp-commerce__notice');
        if (button) button.disabled = !purchaseEnabled || !variant.available;
        if (label && purchaseEnabled) label.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        const selected = this.querySelector('[data-option-position]:checked');
        const output = selected?.closest('fieldset')?.querySelector('[data-option-value]');
        if (output) output.textContent = selected.value;
        const announcement = this.querySelector('[data-variant-announcement]');
        if (announcement) announcement.textContent = `${variant.title} ${variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sptebik-product-detail"] && !Shopify.designMode) return;
  try {
    
  class SptProductDetail extends HTMLElement {
    connectedCallback() {
      this.variantInputs = this.querySelectorAll('[data-variant-input]');
      this.price = this.querySelector('[data-product-price]');
      this.addButton = this.querySelector('[data-add-button]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.announcement = this.querySelector('[data-variant-announcement]');

      for (const input of this.variantInputs) {
        input.addEventListener('change', this.#handleVariantChange.bind(this));
      }
    }

    #handleVariantChange(event) {
      const input = event.currentTarget;
      const available = input.dataset.available === 'true';
      const price = input.dataset.price;

      if (this.price && price) {
        const taxLabel = this.price.querySelector('span');
        this.price.firstChild.textContent = price;
        if (taxLabel) this.price.append(taxLabel);
      }

      if (this.addButton && this.addLabel) {
        this.addButton.disabled = !available;
        this.addLabel.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      if (this.announcement) {
        this.announcement.textContent = '';
        requestAnimationFrame(() => {
          this.announcement.textContent = `${input.nextElementSibling?.textContent ?? ''}、${price}`;
        });
      }
    }
  }

  if (!customElements.get('spt-product-detail')) {
    customElements.define('spt-product-detail', SptProductDetail);
  }

  } catch(e) { console.error(e); }
})();
})();
